export default __webpack_public_path__ + "static/media/hht2_ep12_timeline_q04_a.63113d93.png";